/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { TargetPort } from './TargetPort';
import { TargetPortFromJSON, TargetPortToJSON } from './TargetPort';

/**
 *
 * @export
 * @interface Target
 */
export interface Target {
  /**
   * The unique name of the target server.
   * @type {string}
   * @memberof Target
   */
  name?: string;
  /**
   * The type of the target.
   * @type {string}
   * @memberof Target
   */
  type?: string;
  /**
   * The hostname or IP address of the target.
   * @type {string}
   * @memberof Target
   */
  hostname?: string;
  /**
   *
   * @type {TargetPort}
   * @memberof Target
   */
  port?: TargetPort;
}

/**
 * Check if a given object implements the Target interface.
 */
// @ts-ignore
export function instanceOfTarget(value: object): value is Target {
  return true;
}

export function TargetFromJSON(json: any): Target {
  return TargetFromJSONTyped(json, false);
}

export function TargetFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): Target {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    type: json['type'] == null ? undefined : json['type'],
    hostname: json['hostname'] == null ? undefined : json['hostname'],
    port: json['port'] == null ? undefined : TargetPortFromJSON(json['port']),
  };
}

export function TargetToJSON(json: any): Target {
  return TargetToJSONTyped(json, false);
}

export function TargetToJSONTyped(
  value?: Target | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    type: value['type'],
    hostname: value['hostname'],
    port: TargetPortToJSON(value['port']),
  };
}
